import { lazy, Suspense } from 'react';
import CreateMatterModal from '../components/CreateMatterModal';
import CreateContactModal from '../components/CreateContactModal';
import FeedbackButton from '../components/FeedbackButton';
import QuickNoteModal from '../components/QuickNoteModal';
import PunchClockModal from '../components/PunchClockModal';

const QuickIntakeWizard = lazy(() => import('../components/QuickIntakeWizard'));

interface AppLayoutOverlaysProps {
  showCreateContact: boolean;
  showCreateMatter: boolean;
  showPunchModal: boolean;
  showQuickIntake: boolean;
  showQuickNote: boolean;
  onCloseCreateContact: () => void;
  onCloseCreateMatter: () => void;
  onClosePunchModal: () => void;
  onCloseQuickIntake: () => void;
  onCloseQuickNote: () => void;
  suppressFloatingActions?: boolean;
}

export function AppLayoutOverlays({
  showCreateContact,
  showCreateMatter,
  showPunchModal,
  showQuickIntake,
  showQuickNote,
  onCloseCreateContact,
  onCloseCreateMatter,
  onClosePunchModal,
  onCloseQuickIntake,
  onCloseQuickNote,
  suppressFloatingActions = false,
}: AppLayoutOverlaysProps) {
  return (
    <>
      {showCreateMatter && (
        <CreateMatterModal onClose={onCloseCreateMatter} />
      )}
      {showCreateContact && (
        <CreateContactModal onClose={onCloseCreateContact} />
      )}
      {showQuickIntake && (
        <Suspense fallback={null}>
          <QuickIntakeWizard onClose={onCloseQuickIntake} />
        </Suspense>
      )}
      <QuickNoteModal open={showQuickNote} onClose={onCloseQuickNote} />

      {showPunchModal && <PunchClockModal onClose={onClosePunchModal} />}

      {!suppressFloatingActions && (
        <>
          <FeedbackButton />
        </>
      )}
    </>
  );
}
